// @ngInject
function ArticleChangeItemGroupDialogService($uibModal, ProductsApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(articleId, itemGroups) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'ArticleChangeItemGroupDialogController as vm',
            templateUrl: 'main/product/articles/articleChangeItemGroupDialog/articleChangeItemGroupDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            article: function () {
                return ProductsApiService.getProduct(articleId);
            },
            itemGroups: function () {
                return itemGroups;
            },
            salesChannels: function () {
                return ProductsApiService.getSalesChannels();
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function ArticleChangeItemGroupDialogController($scope, $uibModalInstance, $timeout, article, itemGroups, salesChannels, ProductsApiService, FileOperationsApiService, loadSpinnerService, ResourcesService, ToasterService, $translate) {
    var vm = this;

    vm.selectedArticle = article;
    vm.selectedArticleCopy = angular.copy(vm.selectedArticle);
    vm.newArticleVariantsForNewSuppliers = [];
    vm.itemGroups = itemGroups;
    vm.closeModal = closeModal;
    vm.hasChanged = false;
    vm.isNewItemGroup = false;
    vm.isNewSupplier = false;
    vm.changesToSupplier = false;
    vm.includeSupplierPrices = false;
    vm.availableSubCategories = [];
    vm.availableDepartments = [];
    vm.newSuppliers = [];
    vm.sameSuppliers = [];
    vm.removedSuppliers = [];
    vm.salesChannels = salesChannels;

    vm.changeItemGroup = changeItemGroup;
    vm.copyToAllPrices = copyToAllPrices;
    vm.saveNewItemGroup = saveNewItemGroup;
    vm.setSupplierData = setSupplierData;
    vm.copyAllNewVariantsForSupplierPrices = copyAllNewVariantsForSupplierPrices;
    activate();


    function activate() {
    }

    function changeItemGroup(itemGroup) {
        if (itemGroup) {
            vm.selectedArticleCopy.subCategory = {};
            loadItemGroupData(itemGroup);
        }
    }
    function loadItemGroupData(itemGroup) {
        ProductsApiService.getItemGroup(itemGroup.id).then(function (result) {
            vm.selectedArticleCopy.itemGroup = result;
            loadMainGroupData(result, true);

            vm.selectedArticleCopy.preferredSupplier = result.brand.company;
            vm.selectedArticleCopy.suppliers = result.brand.companies;
            
            vm.removedSuppliers.length = 0;
            vm.sameSuppliers.length = 0;
            vm.newSuppliers.length = 0;

            _.forEach(vm.selectedArticleCopy.suppliers, function(newSupp){
                if (!_.find(vm.selectedArticle.suppliers, function(oldSupp) {return oldSupp.id === newSupp.id; }))
                    vm.newSuppliers.push(newSupp);
                else {
                    vm.sameSuppliers.push(newSupp);
                }
            });
            
            _.forEach(vm.selectedArticle.suppliers, function(oldSupp){
                if (!_.find(vm.sameSuppliers, function(sameSupp) {return sameSupp.id === oldSupp.id; }))
                    vm.removedSuppliers.push(oldSupp);
            });

            _.forEach(vm.selectedArticleCopy.articleVariants, function(av){
                if(av.supplierPrices.length > 0)
                    vm.includeSupplierPrices = true;
            })

            copyAllNewVariantsForSupplierPrices();

            
            console.log(vm.selectedArticleCopy);

            vm.hasChanged = true;
            vm.isNewItemGroup = Boolean(vm.selectedArticleCopy.itemGroup.itemGroupCode !== vm.selectedArticle.itemGroup.itemGroupCode);
            vm.changesToSupplier = Boolean(vm.selectedArticleCopy.preferredSupplier.id !== vm.selectedArticle.preferredSupplier.id || vm.selectedArticleCopy.suppliers.length > 1);
            vm.isNewSupplier = Boolean(vm.removedSuppliers.length > 0 || vm.newSuppliers.length > 0);
        });
    }
    function loadMainGroupData(itemGroup, setDefaults) {
        if (itemGroup) {
            ProductsApiService.getMainGroup(itemGroup.mainGroup.id).then(function (result) {
                vm.selectedArticleCopy.itemGroup.mainGroup = result;

                vm.availableSubCategories = _.sortBy(result.subCategories, function (subCategory) {
                    return subCategory.subCategoryCode;
                });

                vm.availableDepartments = _.sortBy(result.departments, function (department) {
                    return department.departmentCode;
                });
                resolveIntrastats();

                if (setDefaults) {
                    selectDefaultDepartment(result.departments);
                    selectDefaultSubCatgory(result.subCategories);
                    selectDefaultAccounts(result);
                }

                ProductsApiService.getVariant(result.variant2.id).then(function (variant) {
                    vm.variant2 = variant;
                    selectDefaultVat();
                    selectDefaultIntrastat();
                    selectDefaultVariantGroup();
                    selecteDefaultIsVariant();
                    selectDefaultSalechannels(itemGroup);
                });
            });
        }
    }
    function setSupplierData(itemGroup) {
        if (itemGroup) {
                
        }
    }
    function copyAllNewVariantsForSupplierPrices() {

        vm.newArticleVariantsForNewSuppliers.length = 0;
        if(vm.includeSupplierPrices){    
            _.forEach(vm.newSuppliers, function (supplier) {
                _.forEach(vm.selectedArticleCopy.articleVariants, function (variant) {
                    var newVariant = {
                        purchaseCost: variant.purchaseCost,
                        variantDetail1: variant.variantDetail1,
                        variantDetail2: variant.variantDetail2,
                        articleVariantId: variant.id,
                        companyName: supplier.companyName,
                        purchasingCurrency: supplier.purchasingCurrency,
                        preferredSupplierId: supplier.id
                    };

                    vm.newArticleVariantsForNewSuppliers.push(newVariant);
                });
            });
        }

    }
    function resolveIntrastats() {

        var intrastats = [];

        if (vm.selectedArticleCopy.itemGroup) {

            var mainGroup = vm.selectedArticleCopy.itemGroup.mainGroup;
            var subCategory = vm.selectedArticleCopy.subCategory;

            if (mainGroup && mainGroup.intrastats) {
                intrastats = _.unionBy(intrastats, mainGroup.intrastats, 'id');
            }
            if (subCategory && subCategory.intrastats) {
                intrastats = _.unionBy(intrastats, subCategory.intrastats, 'id');
            }

            if (!vm.selectedArticleCopy.intrastat || _.filter(intrastats, { id: vm.selectedArticleCopy.intrastat.id }).length === 0) {
                selectDefaultIntrastat();
            }
        }

        intrastats.forEach(function (intrastat) {
            if (intrastat.internalDescription && intrastat.internalDescription.length > 15) {
                intrastat.internalDescription = intrastat.internalDescription.substr(0, 15) + '...';
            }
        }, this);

        vm.intrastats = intrastats;
    }

    function selectDefaultVat() {
        if (vm.selectedArticleCopy.itemGroup && vm.selectedArticleCopy.itemGroup.vat) {
            var vatId = vm.selectedArticleCopy.itemGroup.vat.id;
            var vat = _.find(vm.vats, function (vat) {
                return vat.id === vatId;
            });
            vm.selectedArticleCopy.vat = vat;


        }
    }

    function selectDefaultSalechannels(itemGroup) {
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('article.checkingSalesChannels') });
        ProductsApiService.getItemGroup(itemGroup.id).then(function (response) {
            itemGroup = response;

            var salesChannels = _.clone(vm.salesChannels);

            if (itemGroup.mainGroup && itemGroup.mainGroup.salesChannels && itemGroup.mainGroup.salesChannels.length > 0) {
                salesChannels = _.intersectionBy(salesChannels, itemGroup.mainGroup.salesChannels, 'id');
            }

            if (itemGroup.brand && itemGroup.brand.salesChannels && itemGroup.brand.salesChannels.length > 0) {
                salesChannels = _.intersectionBy(salesChannels, itemGroup.brand.salesChannels, 'id');
            }

            vm.selectedArticleCopy.salesChannels = salesChannels;
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function selectDefaultDepartment(departments) {
        if (departments.length === 1) {
            vm.selectedArticleCopy.department = departments[0];
        }
    }

    function selectDefaultSubCatgory(subCategories) {
        if (subCategories.length === 1) {
            vm.selectedArticleCopy.subCategory = subCategories[0];
        }
    }

    function selectDefaultAccounts(mainGroup) {
        if (mainGroup.discountAccount) {
            vm.selectedArticleCopy.discountAccount = mainGroup.discountAccount;
        }
        if (mainGroup.salesAccount) {
            vm.selectedArticleCopy.salesAccount = mainGroup.salesAccount;
        }
    }

    function selecteDefaultIsVariant() {
        if (vm.selectedArticleCopy.itemGroup && vm.selectedArticleCopy.itemGroup.mainGroup) {
            vm.selectedArticleCopy.isVariant = vm.selectedArticleCopy.itemGroup.mainGroup.isVariant;
        }
    }
    function selectDefaultIntrastat() {
        if (!vm.hasChanged) {
            return;
        }

        //If exists in both
        if (vm.selectedArticleCopy.itemGroup.mainGroup && vm.selectedArticleCopy.subCategory) {
            var intrastats = _.intersectionBy(vm.selectedArticleCopy.itemGroup.mainGroup.intrastats, vm.selectedArticleCopy.subCategory.intrastats, 'id');
            if (intrastats.length === 1) {
                vm.selectedArticleCopy.intrastat = intrastats[0];
                return;
            }
        }

        //If only one in maingroup
        if (vm.selectedArticleCopy.itemGroup.mainGroup && vm.selectedArticleCopy.itemGroup.mainGroup.intrastats && vm.selectedArticleCopy.itemGroup.mainGroup.intrastats.length === 1) {
            vm.selectedArticleCopy.intrastat = vm.selectedArticleCopy.itemGroup.mainGroup.intrastats[0];
            return;
        }

        //If only one in subCategory
        if (vm.selectedArticleCopy.subCategory && vm.selectedArticleCopy.subCategory.intrastats && vm.selectedArticleCopy.subCategory.intrastats.length === 1) {
            vm.selectedArticleCopy.intrastat = vm.selectedArticleCopy.subCategory.intrastats[0];
            return;
        }
    }

    function selectDefaultVariantGroup() {
        if (vm.selectedArticleCopy.itemGroup.variantGroup2 !== undefined && vm.selectedArticleCopy.itemGroup.variantGroup2 !== null) {
            var groupId = vm.selectedArticleCopy.itemGroup.variantGroup2.id;
            var group = _.find(vm.variant2.variantGroups, function (variantGroup) {
                return variantGroup.id === groupId;
            });
            vm.selectedArticleCopy.variantGroup2 = group;
            changeVariantGroup();
        }
    }

    function copyToAllPrices(sourceArticleVariant) {
        _.forEach(vm.newArticleVariantsForNewSuppliers, function (variant) {
            if (sourceArticleVariant.preferredSupplierId === variant.preferredSupplierId) {
                variant.purchaseCost = sourceArticleVariant.purchaseCost;
            }
        });
    }

    function saveNewItemGroup() {

        var requestObject = {
            articleId: vm.selectedArticleCopy.id,
            newItemGroupId: vm.selectedArticleCopy.itemGroup.id,
            newPreferredSupplierId: vm.selectedArticleCopy.preferredSupplier.id,
            newArticleVariantSupplierPrices: [],
            salesChannelsIds: []
        };

        _.forEach(vm.selectedArticle.salesChannels, function (salesChannel) {
            requestObject.salesChannelsIds.push(salesChannel.id);
        });
        
        _.forEach(vm.newArticleVariantsForNewSuppliers, function (artVarSupp) {
            requestObject.newArticleVariantSupplierPrices.push({
                articleVariantId: artVarSupp.articleVariantId,
                newPurchaseCost: artVarSupp.purchaseCost,
                newSupplierId: artVarSupp.preferredSupplierId
            });
        });

        _.forEach(vm.sameSuppliers, function (sameSupp){
            _.forEach(vm.selectedArticle.articleVariants, function(artVar){
                requestObject.newArticleVariantSupplierPrices.push({
                    articleVariantId: artVar.id,
                    newPurchaseCost: artVar.purchaseCost,
                    newSupplierId: sameSupp.id
                });
            });
        });

        loadSpinnerService.start("mainSpinner");
        ProductsApiService.changeItemGroup(requestObject).then(function (response) {
            var message = `${$translate.instant('common.new')} ${$translate.instant('article.itemgroup')}: ${response.itemGroup.itemGroupCode} ${response.itemGroup.itemGroupLongName}`;
            ToasterService.showSuccess(message, $translate.instant('support.itemGroupChanged'));
            closeModal(true);
        }, function (error) {
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }

    function closeModal(refresh) {
        $uibModalInstance.close(refresh);
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('product.articles.articleChangeItemGroupDialog', [])
    .service('ArticleChangeItemGroupDialogService', ArticleChangeItemGroupDialogService)
    .controller('ArticleChangeItemGroupDialogController', ArticleChangeItemGroupDialogController);